export default "__VITE_ASSET__BcX_qkvi__"